<template>
    <Layout title="Dashboard">
        
            
            
            <div class="flex h-screen" v-if="is('BCSA')" >
                <div class="m-auto" >
                    <div class="flex items-center justify-between" >
                        <Options isLink="campaigns" visText="Campagnes">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 ml-4 mr-2 text-gray-400">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                            </svg>
                            Campagnes
                        </Options>
                        <Options isLink="organisations" visText="Organisaties" class="ml-4">
                            <svg class="w-6 h-6 ml-4 mr-2 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                            </svg>
                            Organisaties
                        </Options>
                        <Options isLink="schedule" visText="Geplande pogingen" class="ml-4">
                            <svg class="w-6 h-6 ml-4 mr-2 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Geplande pogingen
                        </Options>
                    </div>
                    <div class="flex mt-8 items-center justify-between" >
                        <Options isLink="attempts" visText="Verstuurde pogingen">
                            <svg class="w-6 h-6 ml-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> 
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"></path>
                            </svg>
                            Verstuurde pogingen
                        </Options>
                        <Options isLink="templates" visText="Templates" class="ml-4">
                            <svg class="w-6 h-6 ml-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"></path>
                            </svg>
                            Templates
                        </Options>
                        <Options isLink="user" visText="Account beheren" class="ml-4">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 ml-4 mr-2 text-gray-400">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
                            </svg>

                            Account beheren
                        </Options>
                    </div>
                </div>
            </div>

            <div class="flex h-screen" v-if="is('Customer')" >
                <div class="m-auto" >
                    <h1 class="text-lg font-semibold text-center mb-12" >Welkom, {{ $page.props.auth.user.name }}</h1>
                    <div class="flex items-center justify-between" >
                        <Options isLink="campaigns" visText="Campagnes">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 ml-4 mr-2 text-gray-400">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                            </svg>
                            Campagnes
                        </Options>
                        <Options isLink="organisation" visText="Organisaties" class="ml-4">
                            <svg class="w-6 h-6 ml-4 mr-2 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                            </svg>
                            Organisatie
                        </Options>
                        <Options isLink="user" visText="Account beheren" class="ml-4">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 ml-4 mr-2 text-gray-400">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
                            </svg>
                            Account beheren
                        </Options>
                    </div>
                </div>
            </div>

    </Layout>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import Options from '../../components/buttons/optionsBtn.vue';
import Layout from '../../Shared/Layout';
import StarterKit from '@tiptap/starter-kit';

export default {

    components: {
        Layout,
        Options,
        EditorContent,
    },

    props: {
        auth: Object,
    },

    data() {
        return {
        editor: null,
        }
    },
    methods: {

    },
    mounted() {
        this.editor = new Editor({
            extensions: [StarterKit],
            content: '<p>Hallo wereld!</p>',
        })
    },
    beforeDestroy() {
        this.editor.destroy()
    },

}

</script>